import { FocusContent } from "./FocusContent";
import { TypingContent } from "./TypingContent";
import { SafeSearchBanner } from "./SafeSearchBanner";
import { useAccountData } from "../../../../hooks/useAccountData";
import type { SearchContext } from "../../types";

interface SearchDropdownProps {
  inputValue: string;
  cmsContext: string;
  context?: SearchContext;
  channelFilters?: Record<string, number>;
  onNavigate: (path: string) => void;
  onSelectSuggestion: (name: string) => void;
}

export function SearchDropdown({
  inputValue,
  cmsContext,
  context,
  channelFilters,
  onNavigate,
  onSelectSuggestion,
}: SearchDropdownProps) {
  const accountData = useAccountData();
  const isSafeSearchOn = !accountData?.user?.show_mature_content;
  const hasQuery = inputValue.trim().length > 0;

  return (
    <>
      {isSafeSearchOn && <SafeSearchBanner />}
      {hasQuery ? (
        <TypingContent
          query={inputValue.trim()}
          context={context}
          channelFilters={channelFilters}
          onNavigate={onNavigate}
          onSelectSuggestion={onSelectSuggestion}
        />
      ) : (
        <FocusContent
          cmsContext={cmsContext}
          onNavigate={onNavigate}
        />
      )}
    </>
  );
}
